import { supabase } from "../supabase/client";
import { loadStarBalance } from "../economy/starWallet";

const LOCAL_KEY = "lusky:explore-event-queue:v1";
export interface ExploreEventPayload { itemId: string; kind: string; progress?: number; seconds?: number; score?: number; stars?: number; [key: string]: unknown }

export async function recordExploreEvent(childId: string | null, eventType: string, payload: ExploreEventPayload) {
  const event = { client_event_id: crypto.randomUUID(), event_type: eventType, payload, occurred_at: new Date().toISOString() };
  try {
    const queued = JSON.parse(localStorage.getItem(LOCAL_KEY) ?? "[]") as unknown[];
    localStorage.setItem(LOCAL_KEY, JSON.stringify([...queued.slice(-299), event]));
  } catch { /* private mode or full storage */ }
  if (!supabase || !childId || !/^[0-9a-f-]{36}$/i.test(childId)) return;
  try { await supabase.from("learning_events").insert({ child_id: childId, attempt_id: null, ...event }); } catch { /* local queue remains available */ }
}

export async function claimExploreReward(childId: string | null, itemId: string, stars: number, score: number) {
  if (!supabase || !childId || !/^[0-9a-f-]{36}$/i.test(childId)) return null;
  try {
    const { data, error } = await supabase.rpc("claim_task_reward", { p_child_id: childId, p_task_id: `expand:${itemId}`, p_completion_key: `expand:${childId}:${itemId}:v1`, p_stars: stars, p_payload: { source: "explore_game", score } });
    if (error) return null;
    const row = Array.isArray(data) ? data[0] : data;
    const grossTotal = row && typeof row.total_stars !== "undefined" ? Number(row.total_stars) : 0;
    return await loadStarBalance(childId, grossTotal);
  } catch { return null; }
}
export async function claimExploreStarUpgrade(childId: string | null, gameKey: string, previousStars: number, nextStars: number, score: number) {
  if (!supabase || !childId || !/^[0-9a-f-]{36}$/i.test(childId) || nextStars <= previousStars) return null;
  let totalStars: number | null = null;
  for (let star = previousStars + 1; star <= nextStars; star += 1) {
    try {
      const { data, error } = await supabase.rpc("claim_task_reward", {
        p_child_id: childId,
        p_task_id: `expand:${gameKey}`,
        p_completion_key: `expand:${childId}:${gameKey}:star-${star}:v1`,
        p_stars: 1,
        p_payload: { source: "explore_game", gameKey, score, achievedStars: nextStars, awardedStar: star }
      });
      if (error) continue;
      const row = Array.isArray(data) ? data[0] : data;
      if (row && typeof row.total_stars !== "undefined") totalStars = await loadStarBalance(childId, Number(row.total_stars));
    } catch { /* keep remaining star claims retryable through their idempotency keys */ }
  }
  return totalStars;
}